/**
 * Extract a human-readable error message from NestJS/HTTP error objects.
 * Handles both string and string[] shapes that class-validator's ValidationPipe produces.
 */
export function extractErrorMessage(err: unknown, fallback: string): string {
  const raw = (err as { error?: { message?: unknown }; message?: unknown })?.error?.message;
  const msg = raw ?? (err as { message?: unknown })?.message ?? fallback;
  return Array.isArray(msg) ? msg.join(', ') : String(msg);
}

/** 백엔드가 사용자에게 보이라고 내려준 메시지만 꺼낸다. 클라이언트 쪽 예외 문구(예: S3 업로드 실패)는 fallback으로 가린다. */
export function extractBackendMessage(err: unknown, fallback: string): string {
  const raw = (err as { error?: { message?: unknown } })?.error?.message;
  if (raw === undefined || raw === null) return fallback;
  const message = Array.isArray(raw) ? raw.join(', ') : String(raw);
  return message.trim() ? message : fallback;
}
